<template>
  <div>
    <div class="content">
      <p class="text_head">上海万利保险经纪有限公司客户告知书</p>
      <p>尊敬的客户:</p>
      <p class="text_left_indentation">感谢您委托我公司代为办理保险业务。本公司是基于投保人的利益，为投保人与保险公司订立保险合同提供中介服务的保险专业中介机构。为了保护您的合法权益，按照《保险经纪机构监管规定》的要求，本公司应履行客户告知义务，先将有关事项告知如下，请仔细阅读。</p>
      <p>一、公司基本情况</p>
          <p class="text_left_indentation">（一）名称:上海万利保险经纪有限公司</p>
          <p class="text_left_indentation">（二）地址:上海市浦东新区崂山路528号江苏大厦18楼</p>
          <p class="text_left_indentation">（三）许可证名称及编号:经营保险经纪业务许可证编号260382000000800</p>
          <p class="text_left_indentation">（四）业务范围:在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国保监会批准的其他业务。</p>
          <p class="text_left_indentation">（五）经营区域：全国（港、澳、台除外）</p>
          <p class="text_left_indentation">（六）联系方式:021-68391209</p>
      <p>二、请仔细阅读保险条款，重点关注保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算、健康保险产品等待期等内容，并可要求公司业务人员对上述内容进行详细讲解。</p>     
      <p>三、请向本公司客服人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同终止与失效、未成年人投保限额等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果。</p>
      <p>四、本公司承诺将通过有效的技术手段和管理措施对投保人（被保险人或都受益人）的个人信息、投保交易信息等非公开信息进行保密，严格限制保密信息的接触人，妥善保管保密信息；并在与保险公司的数据交换过程中采用加密与验证保证交易安全。</p>
      <p>五、如果您发现本公司客服人员存在误导行为及其他损害您合法权益的行为，可向本公司投诉，投诉电话021-68391209。</p>
      <p class="text_right top bottom">上海万利保险经纪有限公司</p>
      <p class="text_center center_top">客户回执联</p>
      <p>本人/本机构已阅知了上述客户告知内容。</p>
      <p class="text_right">客户名称（签字或盖章）</p>
      <p class="text_right">年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</p>
    </div>

    <div class="footer">
      <div v-if="!imgUrl">
        <div class="agreement">
          <span>
            <van-checkbox class="flex_center" v-model="checked" shape="square" checked-color="#107fea">我已阅读并了解</van-checkbox>
          </span>
        </div>
        <span type="button" @click="submit();" class="signButton" id="signButton" value="立即签名" >立即签名</span>
      </div>
      <span type="button" @click="displayPdf();" class="signButton" id="displayPdf" value="查看签名" v-else>查看签名</span>
    </div>

    <div class="handwritten-name-wrap" v-show="displaySign">
      <van-popup
        v-model="panelVisible"
        title="手写签名"
        :close-on-click-overlay="false"
        class="signNameModel"
      >
        <template v-slot>
          <div class="signWrap">
            <VueSignaturePad
              width="100%"
              height="100%"
              ref="signaturePad"
              :options="options"
            />
            <footer>
              <div class="gtnGroup">
                <van-button type="primary" size="mini" @click="clear">清屏</van-button>
                <van-button type="primary" size="mini" @click="save" :loading="saveBtn">保存</van-button>
              </div>
              <div class="otherSet">
                <div class="penTxt">笔刷大小：</div>
                <div class="circleWrap" :class="{ active: isActive1 }" @click="selSize(1)"><b class="b1"></b></div>
                <div class="circleWrap" :class="{ active: isActive2 }" @click="selSize(2)"><b class="b2"></b></div>
                <div class="circleWrap" :class="{ active: isActive3 }" @click="selSize(3)"><b class="b3"></b></div>
              </div>
            </footer>
          </div>
        </template>
      </van-popup>
    </div>
  </div>  
</template>
<script>
import API from '@/services/h5/my'
export default {
  components: { 

  },
  data() {
    return {
      contractId: null,
      imgUrl: null, // 预览图片的链接
      checked: false,
      displaySign :false,
      saveBtn: false,
      // 签字所需字段
      panelVisible:false,
      panelTitle:"",
      options: {
        penColor: "#000",
        minWidth: 1,    //控制画笔最小宽度
        maxWidth: 1,    //控制画笔最大宽度
      },
      isActive1:true,
      isActive2:false,
      isActive3:false,
    }
  },
  created() {
    this.contractId = this.$route.params.contractId
    this.querySignFile()
  },
  methods: {
    querySignFile() {
      API.getCustomerSign(this.contractId, {}).then(res => {
        let resp = res.data.data
        if(!resp || !resp.imgUrl) {
          return
        }
        this.imgUrl = resp.imgUrl
      })
    },
    submit() {
      if(!this.checked) {
        this.$message.success('请先阅读告知书')
        return
      }

      this.displaySign = true
      this.panelVisible=true;
      this.isActive1=true;
      this.isActive2=false;
      this.isActive3=false;
      this.options = {
        penColor: "#000",
        minWidth: 1,
        maxWidth: 1,
      }
    },
    displayPdf() {
      window.location.href = this.imgUrl;
    },
    //清除
    clear(){
      this.$refs.signaturePad.clearSignature();
    },
    //保存
    save(){
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty)
      console.log(data)

      this.saveBtn = true

      API.saveCustomerSign(this.contractId, {imgData:data}).then(res => {
        console.log("返回的数据", res)
        this.imgUrl = res.data.data.imgUrl
        this.saveBtn = false
        this.panelVisible = false;
        this.displaySign = false
      })
      
    },
    //调节画笔粗细大小
    selSize(val){
      this.options = {
        penColor: "#000",
        minWidth: val,
        maxWidth: val,
      };
      if(val==1){
        this.isActive1=true;
        this.isActive2=false;
        this.isActive3=false;
      }else if(val==2){
        this.isActive1=false;
        this.isActive2=true;
        this.isActive3=false;
      }else if(val==3){
        this.isActive1=false;
        this.isActive2=false;
        this.isActive3=true;
      }
    }
  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
  outline: 0;
  letter-spacing: 1px;
  font-size: 11px;
}
body {
  background: #f7f7f7;
}
.content {
  padding: 10px;
}
.text_head {
  text-align: center;
  font-size: 14px;
}
.text_left_indentation {
  text-indent: 20px;
}
.text_right {
  text-align: right;
}
.text_center {
  text-align: center;
}
.top {
  padding: 16px 0;
}
.bottom {
  border-bottom: 1px solid #ccc;
}
.center_top {
  font-size: 14px;
  padding: 14px 0;
}
.footer {
  text-align: center;
  margin-bottom: 32px;
}
.agreement input {
  vertical-align: middle;
}
.signButton {
  margin-top: 16px;
  text-decoration: none;
  width: 90%;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  background-color: #107fea;
  color: #fff;
  font-weight: bold;
  border: 1px solid #107fea;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  font-size: 16px;
}
.hidden_btn {
  display: none;
}
.flex_center {
  justify-content: center;
}
</style>
<style lang="less" scoped>
.handwritten-name-wrap {
  width: 100%;
  height: 50%;
  .signWrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .signName {
      flex: 1;
      border-top: 1px solid #ccc;
    }
    footer {
      height: 40px;
      border-top: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .gtnGroup {
        width: 50%;
        margin-left: 20px;
        .van-button {
          width: 60px;
        }
      }
      .otherSet {
        width: 50%;
        display: flex;
        align-items: center;
        .penTxt {
          width: 70px;
        }
        .selSize {
          width: 70px;
        }
        .el-select__caret {
          position: absolute;
          right: -3px;
        }
        .b1,
        .b2,
        .b3 {
          display: inline-block;
          background: #000;
          border-radius: 50%;
        }
        .circleWrap {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 18px;
          height: 18px;
          cursor: pointer;
          margin-right: 20px;
        }
        .active { border: 1px dashed #0074d9; }
        .b1 {
          width: 4px;
          height: 4px;
        }
        .b2 {
          width: 6px;
          height: 6px;
        }
        .b3 {
          width: 8px;
          height: 8px;
        }
      }
    }
  }
}
.signNameModel {
  width: 100%;
  height: 50%;
  .vxe-modal--content {
    padding: 0 !important;
  }
}
</style>
